{
  "version": 1,
  "asset_id": "5444310c-d272-41e4-a2cb-f14666856661",
  "project_id": "ede4779f-2e7a-461a-91d6-654024119c69",
  "url": "/__l5e/assets-v1/5444310c-d272-41e4-a2cb-f14666856661/janusz-zielinski.png",
  "r2_key": "a/v1/ede4779f-2e7a-461a-91d6-654024119c69/5444310c-d272-41e4-a2cb-f14666856661/janusz-zielinski.png",
  "original_filename": "janusz-zielinski.png",
  "size": 41156,
  "content_type": "image/png",
  "created_at": "2026-10-21T08:33:30Z"
}
